import { render, staticRenderFns } from "./BaseButtonSchemaIcon.vue?vue&type=template&id=157a7d90&scoped=true&"
import script from "./BaseButtonSchemaIcon.vue?vue&type=script&lang=js&"
export * from "./BaseButtonSchemaIcon.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonSchemaIcon.vue?vue&type=style&index=0&id=157a7d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157a7d90",
  null
  
)

export default component.exports